import styled from 'styled-components';

type BackgroundImageProps = {
  imageUrl: string;
  opacity: string;
  blur?: string;
};

export const BackgroundImageContainer = styled('div')<BackgroundImageProps>`
  width: 100%;
  height: 100%;
  background-image: url(${({ imageUrl }) => imageUrl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: ${({ theme }) => theme.x1}px;
  filter: ${({ opacity, blur }) => `opacity(${opacity}) blur(${blur})`};
  position: absolute;
`;
